import React from "react";
import { useState } from "react";
import DatePicker from "react-date-picker";
import { useSelector } from "react-redux";
import AreaReportGenerator from "../../components/reports/AreaReportGenerator";
import "./styles.scss";
import ReportTables from "./ReportTables";
import { useEffect } from "react";
import { api } from "../../helpers/apiHelper/requestHelper";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/loader/loadingSlice";

export default function LeadCoordinatorReports() {
    const [leads, setLeads] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const reduxData = useSelector((state) => state);
    const dispatch = useDispatch();

    useEffect(() => {
        let year = new Date().getFullYear();
        setStartDate(new Date(year, 0, 1));
        setEndDate(new Date());
    }, []);

    const getStartDate = async () => {
        let response = await api("get", "settings/getDateSettings");

        if (response?.status) {
            setStartDate(new Date(response?.data?.startDate));
        }
    };

    useEffect(() => {
        getStartDate();
    }, []);

    return (
        <>
            <div className="rml-container">
                <text>Report</text>
                <div className="flex">
                    <div>
                        <p>Start Date</p>
                        <DatePicker
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            className="form-control"
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            format="dd/MM/y"
                            value={startDate}
                        />
                    </div>
                    <div className="ml-20">
                        <p>End Date</p>
                        <DatePicker
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            value={endDate}
                            className="form-control"
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                            format="dd/MM/y"
                        />
                    </div>
                </div>
            </div>

            <ReportTables startDate={startDate} endDate={endDate} />
        </>
    );
}
